interface Props {
  className?: string;
}

export default function LoginButton({ className = '' }: Props) {
  const returnTo = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '/';
  const href = `/api/auth/twitch?returnTo=${encodeURIComponent(returnTo)}`;

  return (
    <a
      href={href}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded bg-purple-700 hover:bg-purple-600 text-white text-sm font-medium ${className}`}
    >
      <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true">
        <path d="M2.149 0l-1.612 4.119v16.836h5.731V24h3.224l3.045-3.045h4.657L23.851 13.4V0H2.149zm19.164 12.418l-3.582 3.582h-5.731l-3.045 3.045v-3.045H4.119V1.791h17.194v10.627zM17.731 5.731h-2.149v6.266h2.149V5.731zm-5.731 0H9.851v6.266H12V5.731z" />
      </svg>
      Mit Twitch einloggen
    </a>
  );
}
